import LinkIcon from "@/assets/icons/link.svg";
import { useEpisode } from "@/containers/Episode/context";
import {
  EXTERNAL_LINK_COPY_MAP,
  SOURCE_SHORT_NAME,
} from "@/containers/Episode/utils/constants";
import { extractHostname } from "@/utils";
import TextButton from "@components/TextButton";
import { i18n } from "@lingui/core";

import styles from "./ExternalLink.module.css";

const ExternalLink: React.FunctionComponent = () => {
  const { mentions, source_display, episode_public_url } = useEpisode();
  const mention = mentions[0];

  const getSourceOrHost = () => {
    try {
      if (!mention && episode_public_url) {
        return extractHostname(episode_public_url);
      }
      if (SOURCE_SHORT_NAME.indexOf(mention.source) < 0) {
        return extractHostname(mention.url_with_timing);
      } else {
        const source = source_display || mention.source;
        return source.toLowerCase().includes("twitter") ? "X" : source;
      }
    } catch {
      return null;
    }
  };

  const hostname = getSourceOrHost();
  const url = mention?.url_with_timing || episode_public_url;
  const prefix = mention
    ? i18n._(EXTERNAL_LINK_COPY_MAP[mention.source] || "")
    : i18n._(EXTERNAL_LINK_COPY_MAP.UNKNOWN);

  return url && hostname ? (
    <TextButton
      icon={LinkIcon}
      target="_blank"
      href={url}
      className={styles.root}
      data-testid="external-link"
    >
      {`${prefix} ${hostname}`}
    </TextButton>
  ) : null;
};

export default ExternalLink;
